import React from 'react';
//import { useNavigate, history } from "react-router-dom";

const Footer = (props) => {
  //console.log(props);
  const {user,footertype, onOrderClick} = props;
  if (footertype === "back_only") {
    return <BackFooter />;
  } else if (user) {
    return <AuthFooter onOrderClick={onOrderClick} />;
  } else {
    return <NoAuthFooter />;
  }
  
}

const BackFooter = () => {
  //const navigate = useNavigate();
  return (
    <footer>
      <div className="footer_box py-2">
        <div className="row">
          <div className="col-4 text-center">
            <div> </div>
          </div>
          <div className="col-4 text-center">
          <div> </div>
          </div>
          <div className="col-4 text-center">
            <div className="btn-back" onClick={() => {window.history.back()}}>Back</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

const AuthFooter = ({ onOrderClick }) => {
  return (
    <footer className="footer-fab-only">
      <div className="footer-fab-row">
        <div className="footer-fab-center">
          <a className="btn-add-fab" href="/add_rating">+</a>
        </div>
        <div className="footer-fab-order">
          <div className="btn-order-fab" onClick={onOrderClick}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{display: 'block'}}>
              <polyline points="8 6 12 2 16 6" />
              <polyline points="16 18 12 22 8 18" />
              <line x1="12" y1="2" x2="12" y2="22" />
            </svg>
          </div>
        </div>
      </div>
    </footer>
  );
}

const NoAuthFooter = () => {
  return (
    <div></div>
  );
}

export default Footer;